import { useLocation } from 'react-router-dom';
import { IMessage } from "./Message";
import { IListMessageItem } from "./ListMessage";
import { IReplyButton } from "./ReplyButtonMessage";
import { IPrivacyAndComplianceMessage } from "./PrivacyAndComplianceMessage";
import { IFileUpload } from "./IFileUpload";

export interface IMessengerConnection {

    identifier : string;
    connectionString : string;
    topic : string;
    subscription: string;
    settings: IMessengerSettings;
}

export interface IMessengerSettings {
    helpUrl:string;
    privacyAndComplianceDefaults: string;
    mimeTypes: IMessengerMimeTypes;
}

export interface IMessengerMimeTypes {
    audio: string;
    video: string;
    document: string;
    sticker: string;
    image: string;
}

export class Messenger {


    constructor(private location:{pathname, search, hash}) {}


    private baseUrl : string = "/messenger";

    private url(path:string) : string {
        return this.baseUrl + "/" + path;
    }


    public connected: boolean = false;
    
    public  connection : IMessengerConnection = null;

    public onHistory : (msg:IMessage[]) => void;

    public onSentMessage : (msg:IMessage) => void;

    public async connect(){
    
        if(this.connected)
            return;

        try {

            const response = await fetch(this.url("connect"), {method:"post"});

            if(!response.ok){
                throw new Error(`Could not connect, status: ${response.status}`);
            }

            const data = await response.json();
            //console.log({data:data});
            this.connection = data;//JSON.parse(data);
            this.connected = true;


        }
        catch(err) {

            this.connected = false;
            this.connection = null;

            throw err;
        }

    }

    public async startDialog(dialogId:string)  {



        const response = await fetch(this.url(`startdialog`),{method:"POST",headers: {"Content-Type": "application/json"}, body: JSON.stringify( { connectionId: this.connection.identifier, dialogId: dialogId, location: this.location })});

        if(!response.ok){
            throw new Error(`Could not Start Dialog, status: ${response.status}`);
        }

    }

    public async startSession(dialogId:string, sessionId:string)  {

        const response = await fetch(this.url(`startsession`),{method:"POST",headers: {"Content-Type": "application/json"}, body: JSON.stringify( { connectionId: this.connection.identifier, dialogId: dialogId, sessionId : sessionId, location: this.location })});
        
        console.log("startSession", {response:response});

        if(!response.ok){
            throw new Error(`Could not Start Session, status: ${response.status}`);
        }

        //Process reaction
        //history is returned as a list of JSON strings, map these by parsing
        const data = (await response.json());
        console.log("startSession: data",{dialogId: dialogId, session: sessionId, data: data});
        const history = data.map(m=> { var msg = JSON.parse(m.message); msg["Valid"] = m.valid; return msg});
        
        console.log("startSession: history",{dialogId: dialogId, session: sessionId, data: data, history: history});
        this.onHistory(history);

    }

    public async sendMessage(message: string) {

        const response = await fetch(this.url(`Sendmessage`),{method:"POST",headers: {"Content-Type": "application/json"}, body:JSON.stringify({  connectionId: this.connection.identifier,message: message, location: this.location })});

        if(!response.ok){
            throw new Error(`Could not SendMessage, status: ${response.status}`);
        }

        this.onSentMessage(await response.json());

        

    }

    public async sendListItem(item:IListMessageItem)  {

        const response = await fetch(this.url(`SendListItem`),{method:"POST",headers: {"Content-Type": "application/json"}, body:JSON.stringify({  connectionId: this.connection.identifier,item: item, location: this.location})});

        if(!response.ok){
            throw new Error(`Could not SendListItem, status: ${response.status}`);
        }

        this.onSentMessage(await response.json());

    }

    public async sendReplyButton(item:IReplyButton)  {

        const response = await fetch(this.url(`SendReplyButton`),{method:"POST",headers: {"Content-Type": "application/json"}, body:JSON.stringify({  connectionId: this.connection.identifier,item: item, location: this.location})});

        if(!response.ok){
            throw new Error(`Could not SendReplyButton, status: ${response.status}`);
        }

        this.onSentMessage(await response.json());

    }

    public async sendAudio(data:Blob) {
    
        //console.log("sendAudioMessage", data);

        var form = new FormData();
        form.append('connectionId',this.connection.identifier);
        form.append('mimeType', data.type);
        form.append('audio', data);
        form.append('location', JSON.stringify(this.location));

        const response = await fetch(this.url(`SendAudio`),{method:"POST", body:form});

        if(!response.ok){
            throw new Error(`Could not SendAudio, status: ${response}`);
        }

        var message = await response.json()

        this.onSentMessage(message);


    }

    public async sendMedia(message: string, media:IFileUpload) {
        
        console.log("sendMedia", {message:message,media:media});

         var form = new FormData();
        form.append('connectionId',this.connection.identifier);
        form.append('mimeType', media.LocalFile.type);
        form.append('media', media.LocalFile);
        form.append('message', message);
        form.append('location', JSON.stringify(this.location));

        const response = await fetch(this.url(`SendMedia`),{method:"POST", body:form});

        if(!response.ok){
            throw new Error(`Could not SendMedia, status: ${response}`);
        }

        var sent = await response.json()

        this.onSentMessage(sent);

    }

    public async urlPreview(url:string) : Promise<string> {

        const response = await fetch(this.url(`UrlPreview`),{method:"POST",headers: {"Content-Type": "application/json"}, body:JSON.stringify({  connectionId: this.connection.identifier,url: url})});

        if(!response.ok){
            console.log(`Could not urlPreview, status: ${response.status}`, response)
            throw new Error(`Could not urlPreview, status: ${response.status}`);
        }

        return response.text();


    }

}